"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = set;
exports.get = get;
var store = {};

function set(obj) {
  store = Object.assign(store, obj);
}

function get(key) {
  return store[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/glfx-es6/es/store.js
// module id = 6
// module chunks = 0